import { ShiftRecipeWithUserIDs } from '@models/QontactPoint';
import React, { createContext, useContext, useState } from 'react';

interface TurnosContextProps {
    turnos: ShiftRecipeWithUserIDs[];
    setTurnos: React.Dispatch<React.SetStateAction<ShiftRecipeWithUserIDs[]>>;
    handleAdd: (turno: ShiftRecipeWithUserIDs) => void;
    handleModify: (turno: ShiftRecipeWithUserIDs) => void;
    wasInitialized: boolean;
}

const TurnosContext = createContext<TurnosContextProps | undefined>(undefined);

export const TurnosProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [turnos, _setTurnos] = useState<ShiftRecipeWithUserIDs[]>([]);
    const [wasInitialized, setWasInitialized] = useState<boolean>(false);

    const handleAdd = (turno: ShiftRecipeWithUserIDs) => {
        setTurnos([...turnos, turno]);
    };

    const handleModify = (turno: ShiftRecipeWithUserIDs) => {
        setTurnos(turnos.map(t => t.firestoreRecordId === turno.firestoreRecordId ? turno : t));
    };

    const setTurnos = (value: React.SetStateAction<ShiftRecipeWithUserIDs[]>) => {
        _setTurnos(value);
        if (!wasInitialized) {
            setWasInitialized(true);
        }
    };

    return (
        <TurnosContext.Provider value={{ turnos, setTurnos, handleAdd, handleModify, wasInitialized }}>
            {children}
        </TurnosContext.Provider>
    );
};

export const useTurnos = () => {
    const context = useContext(TurnosContext);
    if (!context) {
        throw new Error('useTurno must be used within a TurnoProvider');
    }
    return context;
};